import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICustomer } from '../../../modules/pay-by-link/interfaces';
import { MobileViewService } from '../../../services/mobile-view.service';
import { UntilDestroy } from '@ngneat/until-destroy';

const CustomMessages = {
  NotFoundMessage: $localize`No customers were found. Please continue by entering the details below.`,
  TypeToSearchMessage: $localize`Type to search`,
  MinCharMessage: $localize`Please enter at least 2 characters to initiate the search.`,
};

@UntilDestroy()
@Component({
  selector: 'portal-customer-search-box',
  templateUrl: './customer-search-box.component.html',
  standalone: false,
})
export class CustomerSearchBoxComponent {
  @Input() customers: ICustomer[] = [];
  @Input() loading = false;
  @Input() showLoadMore = false;
  @Input() searchParam = 'emailAddress';
  @Output() loadMore: EventEmitter<void> = new EventEmitter();
  @Output() searchTerm: EventEmitter<string> = new EventEmitter();
  @Output() selectedCustomer: EventEmitter<ICustomer> = new EventEmitter();

  isDeviceMobile$: Observable<boolean>;

  searchTermValue = '';
  notFoundMessage = CustomMessages.TypeToSearchMessage;
  private isSelecting$ = new BehaviorSubject<boolean>(false);

  constructor(private mobileViewService: MobileViewService) {
    this.isDeviceMobile$ = this.mobileViewService.mobileDevice;
  }

  onClear(): void {
    this.customers = [];
    this.loading = false;
    this.showLoadMore = false;
    this.notFoundMessage = CustomMessages.TypeToSearchMessage;
  }

  onCustomerSelected(customer: ICustomer): void {
    if (customer) {
      this.isSelecting$.next(true);
      this.selectedCustomer.emit(customer);
      this.isSelecting$.next(false);
    } else {
      this.selectedCustomer.emit(null);
      this.customers = [];
    }
  }

  get displayNotFoundText(): string {
    if (!this.searchTermValue.trim()) {
      return CustomMessages.TypeToSearchMessage;
    }
    if (this.searchTermValue.length === 1) {
      return CustomMessages.MinCharMessage;
    }
    return CustomMessages.NotFoundMessage;
  }

  onSearch(term: string): void {
    this.customers = [];
    this.searchTermValue = term;
    if (!term.trim() || term.length === 1) {
      this.loading = false;
      this.searchTerm.emit('');
      return;
    }

    this.loading = true;
    this.searchTerm.emit(term);
  }

  onLoadMore(): void {
    this.loadMore.emit();
  }
}
